export function setHash(newHash: string) {
  /* istanbul ignore next */
  if (window !== undefined) {
    window.history.pushState({}, document.title, `#${newHash}`);
  }
}
